import _ from 'underscore';
import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from '@fluentui/react/lib/Dropdown';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { InstrumentationServiceContext } from '@bingads-webui-campaign-react/smart-page-context';

const getStyles = () => ({
  fbImportDesc: {
    marginTop: 20,
    marginBottom: 20,
  },
  fbReconnect: {
    marginTop: 24,
  },
  fbReconnectLink: {
    color: '#0078D4',
    cursor: 'pointer',
  },
});

const UnStyledFacebookImportDialogStepFBImport = ({
  i18n,
  classes,
  fbSites,
  onFBSiteSelected,
  onReConnectFB,
}) => {
  const transformFBSitesData =
    () => _.map(fbSites, fbSite => ({ key: fbSite.facebookId, text: fbSite.businessName }));

  const options = transformFBSitesData(fbSites);
  const [selectedPage, setSelectedPage] = useState(options[0] ? options[0].key : '');

  const logger = useContext(InstrumentationServiceContext);

  useEffect(() => {
    onFBSiteSelected(selectedPage);
  }, [selectedPage]);

  const onChange = (event, item) => {
    setSelectedPage(item.key);
    logger.logTrace(`FacebookImportDialog|ImportStep|PageDropdownSelection|Selected: ${item.key}`);
  };

  return (
    <div id="facebook-import-dialog-step-fb-import" className={classes.facebookImportDialogStepFBImport}>
      <Dropdown
        placeholder={i18n.getString(_TL_('Select an option'))}
        label={i18n.getString(_TL_('Select the Facebook page to import from:'))}
        options={options}
        selectedKey={selectedPage}
        onChange={onChange}
        calloutProps={{ directionalHintFixed: true }} /* make sure dropdown show only on bottom */
      />
      <div className={classes.fbReconnect}>
        <span>{i18n.getString(_TL_('If you don\'t see your pages listed:'))}</span>
        <ul>
          <li>
            <span
              className={classes.fbReconnectLink}
              onClick={onReConnectFB}
              onKeyPress={onReConnectFB}
              role="link"
              tabIndex="0"
            >
              {i18n.getString(_TL_('Reconnect your Facebook account.'))}
            </span>
          </li>
          <li>
            {i18n.getString(_TL_('Check if you\'re signed in to the correct Facebook account.'))}
          </li>
          <li>
            {i18n.getString(_TL_('Check if you\'re the administrator for the Facebook page in your Facebook account.'))}
          </li>
        </ul>
      </div>
      <div className={classes.fbImportDesc}>
        {i18n.getString(_TL_('We\'ll import your:'))}
      </div>
      <ul>
        <li>
          {i18n.getString(_TL_('Business description'))}
        </li>
        <li>
          {i18n.getString(_TL_('Cover-image'))}
        </li>
        <li>
          {i18n.getString(_TL_('Profile picture'))}
        </li>
        <li>
          {i18n.getString(_TL_('Business hours'))}
        </li>
        <li>
          {i18n.getString(_TL_('Recent posts'))}
        </li>
        <li>
          {i18n.getString(_TL_('Customer reviews'))}
        </li>
      </ul>
    </div>
  );
};

UnStyledFacebookImportDialogStepFBImport.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    itemContainer: PropTypes.string,
  }).isRequired,
  fbSites: PropTypes.arrayOf(PropTypes.any),
  onFBSiteSelected: PropTypes.func,
  onReConnectFB: PropTypes.func,
};

UnStyledFacebookImportDialogStepFBImport.defaultProps = {
  fbSites: [],
  onFBSiteSelected: _.noop,
  onReConnectFB: _.noop,
};

export const FacebookImportDialogStepFBImport = withDefaultStyles(
  withI18nConsumer(UnStyledFacebookImportDialogStepFBImport),
  getStyles
);
